var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"individual-chart",class:_vm.wrapperClass},[_c('sectionHeader',{attrs:{"title":_vm.name}}),_c('v-chart',{class:_vm.className,attrs:{"option":_vm.chartDataSourcesAllocation,"autoresize":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }